var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAdminDashboard)?_c('v-main',[_c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('admin-dashboard')],1)],1):_c('shortcuts-page')
}
var staticRenderFns = []

export { render, staticRenderFns }